import { useCallback, useEffect, useMemo, useRef, useState } from "react";

const useCountdown = ({ count = 10, startCountdown = false, id = "", }) => {
  const [timeLeft, setTimeLeft] = useState(count);
  const [countEnded, setCountEnded] = useState(false);
  const timerKeyRef = useRef(null);
  const intervalRef = useRef(null);

  const formattedTime = useMemo(() => {
    const minutes = Math.floor(Math.max(0, timeLeft) / 60);
    const seconds = Math.max(0, timeLeft) % 60;
    return `${minutes}m:${String(seconds).padStart(2, "0")}s`;
  }, [timeLeft]);

  const clearTimer = useCallback(() => {
    if (timerKeyRef.current) {
      localStorage.removeItem(timerKeyRef.current);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  }, [])

  useEffect(() => {
    if (!startCountdown) return;

    const key = `cd_t_${id || "d"}`;
    timerKeyRef.current = key;

    const saved = parseInt(localStorage.getItem(key), 10);
    let timeLeftToSave = !isNaN(saved) && saved > 0 ? saved : count;
    setTimeLeft(timeLeftToSave);

    // clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }


    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev - 1;
        localStorage.setItem(key, String(Math.max(0, next)));

        if (next <= 0) {
          // stop timer and auto-submit
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          localStorage.removeItem(key);
          setCountEnded(true);
          return 0;
        }

        timeLeftToSave = next;
        return next;
      });
    }, 1000);


    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      // persist remaining time on unmount
      const k = timerKeyRef.current;
      if (k) localStorage.setItem(k, String(timeLeftToSave));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, startCountdown, count]);

  return {
    timeLeft, formattedTime, clearTimer, countEnded
  };
};

export default useCountdown;
